import {initWechatAPI} from '@/api/index';
import http from './http';
import {getLocalStorage} from '@/utils/local-storage';
import wx from 'wx-jssdk-ts';

export function initWeChat() {
  return new Promise((resolve, reject) => {
    const localStorageData = getLocalStorage();
    const { wxUserInfo } = localStorageData;

    const body = {
      companyKey: '',
      url: `${window.location.origin}${window.location.pathname}`,
      type: 'jsapi',
      ispay: '0',
    };

    if (wxUserInfo) {
      body.companyKey = wxUserInfo.companyKey;
    }

    initWechatAPI.requestInit.body = JSON.stringify(body);

    http(initWechatAPI).then((res: any) => {
      const {
        appid,
        nonceStr,
        signature,
        timestamp,
      } = res;

      wx.config({
        debug: false,
        appId: appid,
        timestamp,
        nonceStr,
        signature,
        jsApiList: [
          'hideMenuItems',
          'updateAppMessageShareData',
        ],
      });

      wx.ready(() => {
        console.log('wechatReady');
        resolve();
      });

      wx.error((err) => {
        console.log('wechatError');
        reject(err.errMsg);
      });
    });
  });
}
